import React from 'react';
import ParallaxHeader from '../components/Parallaxheader';

const courseList = [
  {
    name: "Master Chess Program",
    description: "Comprehensive chess training for all skill levels",
    image: "/images/course/homebasic.jpg",
    duration: "1 Hour / Session",
    sessionsPerWeek: 3,
    fee: "₹1000 per month",
    rating: 4.9,
    reviews: 128,
    href: "/courses/beginner",
    scheduleOptions: [
      "Monday, Wednesday, Friday",
      "Tuesday, Thursday, Saturday"
    ],
    classFormats: [
      "Online classes",
      "Offline classes",
      "Group class",
      "One on One sessions"
    ],
    features: [
      "Free demo session",
      "One-on-one sessions available (Sat/Sun)",
      "Personalized coaching",
      "Tournament preparation and game lesson provided"  // Changed this line
    ],
    specialTraining: {
      available: true,
      description: "Intensive training available every day for players with a national/international chess rating"
    },
    compensationPolicy: "If the trainer is on leave, a compensation class will be provided. However, if a student is absent, a makeup session will not be offered.",
    contact: {
      email: "thirumaladmissions@gmail.com",
      whatsapp: "+91 95669 63270",
      website: "Thirumal Chess Academy",
      location: "https://maps.app.goo.gl/rTeJMhuYwHM4g8Ut7"
    },
    instructor: {
      name: "VS Kalyan",
      title: "Founder and Head coach",
      experience: "15+ years coaching"
    }
  }
];

const Courses = () => {
  return (
    <>
      <ParallaxHeader
        title="Explore our courses"
        breadcrumbs={[{ title: 'Courses', path: '/courses' }]}
        backgroundImage="/images/aboutheader.jpg"
        overlayColor="rgba(0, 0, 0, 0.7)"
      />
      <section className="py-10 md:py-20 bg-gradient-to-b from-[#f8f5ed] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-16">
            <div className="inline-block bg-amber-100 text-amber-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
              Thirumal Chess Academy
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 tracking-tight px-4" data-aos="fade-up">
              The Ultimate Chess Mastery Program
            </h2>
            <p className="mt-4 md:mt-6 text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4" data-aos="fade-up" data-aos-delay="100">
              Comprehensive chess training with flexible schedules and expert coaching
            </p>
          </div>
          
          {/* Premium Course Card */}
          <div className="max-w-5xl mx-auto px-2 sm:px-0">
            {courseList.map((course, index) => (
              <div 
                key={index}
                className="relative overflow-hidden rounded-2xl shadow-2xl bg-gradient-to-br from-[#1a1a1a] to-[#0d0d0d] text-white"
                data-aos="zoom-in"
              >
                <div className="flex flex-col md:flex-row">
                  {/* Course Image */}
                  <div className="md:w-2/5 relative">
                    <img 
                      src={course.image} 
                      alt={course.name}
                      className="w-full h-[250px] md:h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                    <div className="absolute bottom-6 left-6 right-6">
                      <h3 className="text-2xl md:text-3xl font-bold font-serif">{course.name}</h3>
                      <p className="text-amber-300 mt-1 text-sm md:text-base">{course.description}</p>
                    </div>
                  </div>
                  
                  {/* Course Details */}
                  <div className="md:w-3/5 p-4 sm:p-6 md:p-8">
                    {/* Stats Grid - Changed to single column on mobile, 2 columns on tablet+ */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6 md:mb-8">
                      <div className="flex items-center">
                        <div className="bg-gray-800 rounded-lg p-2 sm:p-3 mr-3 sm:mr-4 flex-shrink-0">
                          <svg className="h-5 w-5 sm:h-6 sm:w-6 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-400 text-xs sm:text-sm">Fee</p>
                          <p className="font-medium text-sm sm:text-base">{course.fee}</p>
                        </div>
                      </div>
                      
                      <div className="flex items-center">
                        <div className="bg-gray-800 rounded-lg p-2 sm:p-3 mr-3 sm:mr-4 flex-shrink-0">
                          <svg className="h-5 w-5 sm:h-6 sm:w-6 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-400 text-xs sm:text-sm">Schedule</p>
                          <p className="font-medium text-sm sm:text-base">{course.sessionsPerWeek} sessions/week</p>
                        </div>
                      </div>
                      
                      <div className="flex items-center">
                        <div className="bg-gray-800 rounded-lg p-2 sm:p-3 mr-3 sm:mr-4 flex-shrink-0">
                          <svg className="h-5 w-5 sm:h-6 sm:w-6 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-400 text-xs sm:text-sm">Duration</p>
                          <p className="font-medium text-sm sm:text-base">{course.duration}</p>
                        </div>
                      </div>
                      
                      <div className="flex items-center">
                        <div className="bg-gray-800 rounded-lg p-2 sm:p-3 mr-3 sm:mr-4 flex-shrink-0">
                          <svg className="h-5 w-5 sm:h-6 sm:w-6 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-gray-400 text-xs sm:text-sm">Training</p>
                          <p className="font-medium text-sm sm:text-base">Tournament Prep</p>
                        </div>
                      </div>
                    </div>
                    
                    {/* Schedule Options */}
                    <div className="mb-5 md:mb-6">
                      <h4 className="text-lg md:text-xl font-bold mb-2 md:mb-3">📅 Available Schedules</h4>
                      <div className="flex flex-wrap gap-2">
                        {course.scheduleOptions.map((option, idx) => (
                          <span key={idx} className="bg-gray-800 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm">
                            {option}
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* Class Formats */}
                    <div className="mb-5 md:mb-6">
                      <h4 className="text-lg md:text-xl font-bold mb-2 md:mb-3">🎓 Class Formats</h4>
                      <div className="flex flex-wrap gap-2">
                        {course.classFormats.map((format, idx) => (
                          <span key={idx} className="bg-gray-800 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm">
                            {format}
                          </span>
                        ))}
                      </div>
                    </div>
                    
                    {/* Course Features - Changed to single column on mobile */}
                    <div className="mb-5 md:mb-6">
                      <h4 className="text-lg md:text-xl font-bold mb-2 md:mb-3">✨ What's Included</h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                        {course.features.map((feature, idx) => (
                          <div key={idx} className="flex items-center">
                            <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mr-2 sm:mr-3 flex-shrink-0"></div>
                            <span className="text-sm sm:text-base">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Special Training */}
                    {course.specialTraining.available && (
                      <div className="mb-5 md:mb-6 p-3 sm:p-4 bg-amber-500/10 rounded-xl border border-amber-500/30">
                        <h4 className="text-base md:text-xl font-bold mb-1 md:mb-2 text-amber-400">⭐ Special Training for Rated Players</h4>
                        <p className="text-xs sm:text-sm">{course.specialTraining.description}</p>
                      </div>
                    )}

                    {/* Compensation Policy */}
                    <div className="mb-5 md:mb-6 p-2 sm:p-3 bg-gray-800/50 rounded-lg">
                      <p className="text-xs text-gray-400">
                        <strong className="text-amber-400">Note:</strong> {course.compensationPolicy}
                      </p>
                    </div>
                    
                    {/* Instructor */}
                    <div className="mb-5 md:mb-6">
                      <h4 className="text-lg md:text-xl font-bold mb-2 md:mb-3">Your Instructor</h4>
                      <div className="flex items-center">
                        <div className="bg-gray-200 border-2 border-dashed rounded-xl w-12 h-12 sm:w-16 sm:h-16 mr-3 sm:mr-4 flex-shrink-0" />
                        <div>
                          <p className="font-bold text-sm sm:text-base">{course.instructor.name}</p>
                          <p className="text-gray-400 text-xs sm:text-sm">{course.instructor.title} • {course.instructor.experience}</p>
                        </div>
                      </div>
                    </div>
                    
                    {/* Rating and CTA - Stack on mobile */}
                    <div className="flex flex-col sm:flex-row items-center justify-between pt-4 sm:pt-6 border-t border-gray-800 gap-4">
                      <div className="flex items-center">
                        <div className="flex text-amber-400 mr-2">
                          {"★".repeat(Math.floor(course.rating))}
                          {"☆".repeat(5 - Math.floor(course.rating))}
                        </div>
                        <div>
                          <p className="font-bold text-sm sm:text-base">{course.rating}/5</p>
                          <p className="text-xs text-gray-400">{course.reviews} student reviews</p>
                        </div>
                      </div>
                      
                      <a
                        href="https://forms.gle/eVCjEj7xvBud1ugw9"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-xl transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl shadow-lg shadow-amber-500/20 flex items-center text-sm sm:text-base w-full sm:w-auto justify-center"
                      >
                        Enroll Today
                      </a>
                    </div>

                    {/* Contact Information */}
                    <div className="mt-5 md:mt-6 pt-3 md:pt-4 border-t border-gray-800 text-center text-xs text-gray-400">
                      <p className="break-words">📧 {course.contact.email} | 💬 WhatsApp: {course.contact.whatsapp}</p>
                      <p className="mt-1">📍 <a href={course.contact.location} target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:underline break-words">View Location on Map</a></p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Courses;